export const MRP_ND_TO_PD_V1_SPECIAL_RULES_BY_PLANT = {
  1494: {
    specialProcurementPlants: ['1494', '2601'],
    preSchedulingMarginTargetsIfBlank: ['2601'],
    plannedDeliveryTargets: [
      {
        plant: '2601',
        plannedDeliveryTimeInDays: 3,
      },
    ],
    pdTargets: [
      {
        plant: '1464',
        setMrpControllerIfBlank: true,
        setSchedulingMarginIfBlank: true,
      },
    ],
  },
  2601: {
    specialProcurementPlants: ['1494', '2601'],
    pdTargets: [
      {
        plant: '1464',
        setMrpControllerIfBlank: true,
        setSchedulingMarginIfBlank: true,
      },
      {
        plant: '1494',
        onlyIfMrpType: 'ND',
        setMrpControllerIfBlank: true,
        setSchedulingMarginIfBlank: true,
      },
    ],
  },
  2606: {
    specialProcurementPlants: ['2603', '2606', '2714'],
    preSchedulingMarginTargetsIfBlank: ['2603', '2714'],
    plannedDeliveryTargets: [
      {
        plant: '2603',
        plannedDeliveryTimeInDays: 3,
      },
      {
        plant: '2714',
        plannedDeliveryTimeInDays: 3,
      },
    ],
    pdTargets: [
      {
        plant: '2605',
        setMrpControllerIfBlank: true,
        setSchedulingMarginIfBlank: true,
      },
    ],
  },
  2603: {
    specialProcurementPlants: ['2603', '2606', '2714'],
    pdTargets: [
      {
        plant: '2605',
        setMrpControllerIfBlank: true,
        setSchedulingMarginIfBlank: true,
      },
      {
        plant: '2606',
        onlyIfMrpType: 'ND',
        setMrpControllerIfBlank: true,
        setSchedulingMarginIfBlank: true,
      },
    ],
  },
  2714: {
    specialProcurementPlants: ['2714', '2603', '2606'],
    pdTargets: [
      {
        plant: '2605',
        setMrpControllerIfBlank: true,
        mrpControllerValue: '004',
        setSchedulingMarginIfBlank: true,
      },
      {
        plant: '2606',
        onlyIfMrpType: 'ND',
        setMrpControllerIfBlank: true,
        mrpControllerValue: '004',
        setSchedulingMarginIfBlank: true,
      },
    ],
  },
};

const SPECIAL_RULE_PD_TARGET_PREFETCH_BY_PLANT = {
  1494: ['1464', '2601'],
  2601: ['1464', '1494'],
  2606: ['2603', '2605', '2714'],
  2603: ['2605', '2606', '2714'],
  2714: ['2603', '2605', '2606'],
};

export const getMrpNdToPdV1SpecialRule = (plant) => MRP_ND_TO_PD_V1_SPECIAL_RULES_BY_PLANT[plant?.toString()];

export const getSpecialRulePdTargetPlants = (plant) => SPECIAL_RULE_PD_TARGET_PREFETCH_BY_PLANT[plant?.toString()] || [];
